<mat-toolbar color="primary">
    <span>Contacts</span>
    <button (click)="newContact()" mat-icon-button class="example-icon favorite-icon" aria-label="Example icon-button with heart icon">
        <mat-icon>note_add</mat-icon>
    </button>
    <span class="toolbar-spacer"></span>
    <form class="panel-header-search">
        <mat-form-field class="panel-header-search" appearance="legacy">
            <input type="text" [disabled]="isSearching" matInput #searchInput>
            <fa-icon matSuffix [icon]="['fas','search']"></fa-icon>
        </mat-form-field>
    </form>  
</mat-toolbar>
<app-contact-table #contactTable></app-contact-table>